module.exports = __webpack_public_path__ + "img/t1.b961364f.jpg";